import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type ParentDetails } from '../model/parent.type';

export const getParentByStudentId = async (studentId?: string) => {
  const response = await baseAPI.get<ParentDetails>(
    `studios/get/parent/${studentId}`,
  );
  return response.data;
};

export const getParentByStudentIdOptions = (studentId?: string) =>
  queryOptions({
    queryKey: [KEYS.PARENT, studentId],
    queryFn: () => getParentByStudentId(studentId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!studentId,
  });

export const useGetParentByStudentId = (studentId?: string) => {
  return useQuery(getParentByStudentIdOptions(studentId));
};
